import React, { useState, useEffect, Fragment } from 'react';
import GamesContainer from './GamesContainer';
import gamesService from '../../gameData/services/gamesService';
import layoutConstants from '../constants/layoutConstants';
import { usePerTabSession } from '../../../../ts/react/common/hooks/usePerTabSession';
import { SessionInfoType } from '../../../../ts/react/common/constants/eventStreamConstants';

function GamesList(props) {
  const { translate } = props;
  const [sortsData, setSortsData] = useState([]);
  const [sortStyle, setSortStyle] = useState('');
  const [timeFiltersData, setTimeFiltersData] = useState([]);
  const [pageContext, setPageContext] = useState({});

  usePerTabSession(SessionInfoType.DiscoverPageSessionInfo, true);

  useEffect(() => {
    let isSubscribed = true;
    gamesService.getGamesSorts(null, true).then(
      result => {
        if (isSubscribed) {
          setPageContext(result?.pageContext);
          setSortStyle(
            layoutConstants.isDesktop && result?.gameSortStyle ? result.gameSortStyle : ''
          );
          setTimeFiltersData(result?.timeFilters);
          if (result?.sorts) {
            setSortsData(result.sorts);
          }
        }
      },
      error => {
        console.debug(error);
      }
    );
    return () => {
      isSubscribed = false;
    };
  }, []);

  return (
    <Fragment>
      <div className='section'>
        <div className='games-list-header'>
          <h1>{translate('Label.Discover')}</h1>
        </div>
      </div>
      {sortsData.length > 0 &&
        sortsData.map((sort, index) => {
          return (
            <GamesContainer
              sortPosition={index}
              sort={sort}
              sortStyle={sortStyle}
              pageContext={pageContext}
              timeFilters={timeFiltersData}
              key={sort.token + sort.displayName}
              {...props}
            />
          );
        })}
    </Fragment>
  );
}

export default GamesList;
